import React from 'react'
import styled from 'styled-components'
import { Map, GoogleApiWrapper } from 'google-maps-react'

const MapWrapper = ({ width, height, google }) => {
  return (
    <Wrapper width={width} height={height}>
      <Map
        containerStyle={{ position: 'relative', width: '100%', height: '100%' }}
        style={{ position: 'relative', width: '100%', height: '100%' }}
        google={google}
        zoom={14}
      ></Map>
    </Wrapper>
  )
}

export default GoogleApiWrapper({
  apiKey: process.env.YOUR_GOOGLE_API_KEY_GOES_HERE,
})(MapWrapper)

const Wrapper = styled.div`
  width: ${(props) => props.width || '1200px'};
  height: ${(props) => props.height || '400px'};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
